import React, { useState } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParallaxStory from "@/components/ParallaxStory";
import EnquiryDialog from "@/components/EnquiryDialog";

export default function Garden() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Navigation />
      <ParallaxStory images={["/img/garden-table.jpg", "/img/garden-roses.jpg", "/img/wisteria.jpg"]} testid="garden-page">
        <p className="font-display text-xl md:text-2xl text-parchment leading-relaxed">
          The walled gardens are available for hire separately from the house; by
          morning, afternoon or evening.
        </p>
        <p className="font-display text-xl md:text-2xl text-parchment leading-relaxed mt-6">
          Please{" "}
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="font-bold hover:text-parchment/80 transition-colors"
            data-testid="garden-enquire-link"
          >
            enquire
          </button>.
        </p>
      </ParallaxStory>
      <EnquiryDialog open={open} onClose={() => setOpen(false)} />
      <Footer />
    </>
  );
}
